"use strict";

exports.__esModule = true;
var _exportNames = {
  reportPermissions: true
};
exports.reportPermissions = void 0;
var _Access = require("./Access");
Object.keys(_Access).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Access[key]) return;
  exports[key] = _Access[key];
});
var _AuthContext = require("./AuthContext");
Object.keys(_AuthContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _AuthContext[key]) return;
  exports[key] = _AuthContext[key];
});
var _Role = require("./Role");
Object.keys(_Role).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Role[key]) return;
  exports[key] = _Role[key];
});
var _User = require("./User");
Object.keys(_User).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _User[key]) return;
  exports[key] = _User[key];
});
var _constants = require("./constants");
exports.reportPermissions = _constants.reportPermissions;